import { UserClaims } from "../../types/Claim";
import { post } from "../../utils/axios-config";
import { GET_USER_CLAIMS } from "../../utils/constants";

export const addUserClaims = async (data:UserClaims)=>  await post<UserClaims, boolean>(GET_USER_CLAIMS, data);